import { Button } from "@/components/ui/button";

type CookieConsentBannerProps = {
	onAccept: () => void;
	onReject: () => void;
};

export default function CookieConsentBanner({ onAccept, onReject }: CookieConsentBannerProps) {
	return (
		<div className="fixed inset-x-0 bottom-0 z-50 border-t border-slate-200 bg-white/95 backdrop-blur">
			<div className="mx-auto flex w-full max-w-6xl flex-col items-start justify-between gap-3 px-6 py-4 sm:flex-row sm:items-center">
				<p className="text-sm text-slate-700">
					We use cookies for analytics to improve Text Formatter.
				</p>
				<div className="flex gap-2">
					<Button type="button" variant="outline" onClick={onReject}>
						Reject
					</Button>
					<Button type="button" onClick={onAccept}>
						Accept
					</Button>
				</div>
			</div>
		</div>
	);
}
